module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1046-9e72853d2841625261ead7d574fd92b2.png";